interface IProcedures {
    setFreeMode: () => void;
    setFPSMode: () => void;
    set360Mode: () => void;
    setFloor: (floor: string) => void;
    moveTo: (target: string) => void;
}

interface IMapProcedures {
    updatePlayer: (data: any) => void;
    updateActiveFloor: (floor: string) => void;
}

class Puzzles {
    public procedures: IProcedures | null = null;
    public mapProcedures: IMapProcedures | null = null;
    public setProcedures(procedures: any) {
        this.procedures = procedures;
    }

    public setMapProcedures(mapProcedures: any) {
        this.mapProcedures = mapProcedures;
    }

}

const puzzles = new Puzzles();
export default puzzles;
